export function a11yProps(name, index) {
	return {
		id: `${name}-tab-${index}`,
		'aria-controls': `${name}-tabpanel-${index}`,
	};
}
